// Recherche contacts — brique UNIQUE + testée.
// Règle clé (verrou anti-régression) : l'e-mail n'est cherché QUE si la requête
// contient « @ ». Sinon, taper un mot présent dans un domaine partagé
// (ex. « gmail ») remonterait toute la base. Nom / ville / tél : toujours cherchés.

export function contactMatchesQuery(c, query) {
  const q = String(query || '').toLowerCase().trim();
  if (!q) return true;
  if (!c) return false;
  const searchEmail = q.includes('@');
  return (
    `${c.first_name || ''} ${c.last_name || ''}`.toLowerCase().includes(q) ||
    (c.city || '').toLowerCase().includes(q) ||
    (c.phone || '').includes(q) ||
    (searchEmail && (c.email || '').toLowerCase().includes(q))
  );
}
